import {
    SelectInputOption,
    SelectInputProps,
    SingleSelectInputProps,
    MultipleSelectInputProps,
} from './SelectInput.types'

export const isSingleSelect = (props: SelectInputProps): props is SingleSelectInputProps => !props.multiple

export const isMultipleSelect = (props: SelectInputProps): props is MultipleSelectInputProps => props.multiple

export const getOptionById = (options: SelectInputOption[], id: string): SelectInputOption | undefined =>
    options.find((option) => option.id === id)

export const isOptionSelected = (props: SelectInputProps, optionId: string): boolean => {
    if (isMultipleSelect(props)) {
        return props.selected.includes(optionId)
    }
    return props.selected === optionId
}

export const renderValueForSingle = (
    selected: string | string[],
    getOptionById: (id: string) => SelectInputOption | undefined,
    placeholder: string
) => {
    const selectedOption = getOptionById(selected as string)
    return selectedOption ? selectedOption.label : placeholder
}

export const renderValueForMultiple = (
    selected: string | string[],
    getOptionById: (id: string) => SelectInputOption | undefined,
    placeholder: string,
    optionsCount: number
) => {
    const selectedArray = selected as string[]

    if (selectedArray.length === 0) {
        return `No ${placeholder}`
    }

    if (selectedArray.length === optionsCount) {
        return 'All'
    }

    const selectedOptions = selectedArray.map((id) => getOptionById(id)).filter(Boolean)
    return selectedArray.length === 1 ? selectedOptions[0]?.label : `${selectedOptions.length} ${placeholder}`
}
